<!-- 个人中心 -->
<template>
  <div class="personalCenter">
    <p class="title">个人中心</p>
    <div class="yuE">
      <div>
        <p>余额 / 元</p>
        <p>{{data.account_balance}}</p>
      </div>
      <div>
        <p>总额 / 元</p>
        <p>{{data.all_redit_money}}</p>
      </div>
    </div>
    <div class="xiangqing">
      <p>充值详情</p>
      <div>
        <el-form ref="form" label-width="80px">
          <el-form-item label="筛选月份">
            <el-date-picker
              style="width:200px"
              v-model="month"
              type="month"
              placeholder="筛选"
              @change="changeMouth"
              format="yyyy-MM"
              :clearable="false"
              value-format="yyyy-MM"
            ></el-date-picker>
          </el-form-item>
          <div class="zhishouru">
            <span>结算</span>
            ￥{{data.month_disburse_money}}
            &nbsp;
            <span>充值</span>
            ￥ {{data.month_income_money}}
          </div>
        </el-form>
      </div>
      <div class="list">
        <div v-for="(item,index) in data.detail" :key="index">
          <div class="titleL">{{item.deduction_cilent_name||item.agent_company_name}}</div>
          <div class="create_time">{{item.create_time}}</div>
          <div class="credit" v-if="item.credit">+ {{item.credit}}</div>
          <div class="deduction" v-else>- {{item.deduction}}</div>
        </div>
      </div>
      <div class="kong" v-if="data.detail.length==0">记录为空</div>
    </div>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { require } from '@/utils/http_request.js'

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      data: {
        account_balance: 0,
        all_redit_money: 0,
        detail: [],
        month_disburse_money: 0,
        month_income_moneyL: 0,
      },
      tableData: [
        {
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
        },
        {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
        },
        {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
        },
        {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄',
        },
      ],
      month: '',
      search: {},
    }
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    init() {
      require('post', '/lufish_user/v1/account_balance_list/', this
        .search).then((res) => {
        if (!res.code) {
          console.log(res)
          this.data = res.data
        }
      })
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return 'warning-row'
      } else return 'success-row'
    },
    changeMouth() {
      console.log(this.month)
      this.search = {
        year: this.month.substring(0, 4),
        month: this.month.substring(5, this.month.length),
      }
      this.init()
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.init()
    var date = new Date()
    let month = date.getMonth() + 1 + ''
    console.log(month) //获取当前月份(0-11,0代表1月) //获取完整的年份(4位)
    month = month.length == 1 ? '0' + month : month
    this.month = date.getFullYear() + '-' + month
    console.log(month) //获取当前月份(0-11,0代表1月) //获取完整的年份(4位)
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
}
</script>
<style  scoped>
/* //@import url(); 引入公共css类 */
.personalCenter {
  position: relative;
  top: 80px;
  left: 200px;
  width: calc(100% - 220px);
  background: rgb(242 242 242);
  min-height: 80vh;
  margin-bottom: 50px;
}
.title {
  text-align: center;
  font-size: 34px;
  margin: 0;
  padding: 20px 0;
  font-weight: bold;
  color: #6c6c6c;
  text-shadow: 5px 5px 5px #8f8f8f;
}
.yuE {
  width: calc(80% - 4px);
  margin: auto;
  overflow: hidden;
  margin-bottom: 20px;
  background: rgba(62, 132, 233, 0.8);
  border: #acacac solid 2px;
  border-radius: 20px;
  box-shadow: #acacac 2px 4px 12px 2px;
}
.yuE > div {
  width: 50%;
  float: left;
  text-align: center;
}
.yuE > div > p:first-child {
  font-size: 20px;
  /* font-weight: 600; */
  color: #f8f8f8;
}
.yuE > div > p:last-child {
  font-size: 30px;
  font-weight: 700;
  color: #f8f8f8;
}
.xiangqing {
  width: 80%;
  margin: auto;
}
.el-table /deep/ .warning-row {
  background: rgba(62, 132, 233, 0.1);
}

.el-table /deep/ .success-row {
  background: rgba(94, 228, 22, 0.1);
}
.xiangqing > p {
  /* text-align: center; */
  font-size: 20px;
  margin: 0;
  padding: 20px 0;
  font-weight: 600;
  color: #494949;
}

.zhishouru > span {
  color: rgb(146, 146, 146);
}
.list {
  padding-top: 20px;
}
.list > div {
  padding: 20px 30px;
  height: 58px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.8);
  box-shadow: #dbdbdb 2px 10px 13px 0px;
  margin-bottom: 20px;
  position: relative;
}
.list > div > .titleL {
  position: absolute;
  top: 12px;
  margin: 0;
  font-size: 20px;
  font-weight: bold;
}
.list > div > .create_time {
  position: absolute;
  bottom: 12px;
  margin: 0;
  font-size: 16px;
}
.list > div > .credit,
.list > div > .deduction {
  position: absolute;
  right: 30px;
  margin: 0;
  top: 50%;
  margin-top: -26px;
  font-size: 40px;
}
.list > div > .deduction {
  color: #fb0707;
}
.list > div > .credit {
  color: #fb9107;
}
.kong {
  line-height: 200px;
  background: #ffffff;
  text-align: center;
  color: #8d8d8d;
  font-size: 20px;
}
</style>


// WEBPACK FOOTER //
// src/personalCenter/personalCenter.vue